export default {
  vacancies: 'REQUEST_FOR_LABOUR',
  applicants: 'APPLICANT',
  attachments: 'ATTACHMENT'
}
